import { render, staticRenderFns } from "./Providers.vue?vue&type=template&id=6f4a3368&scoped=true&"
import script from "./Providers.vue?vue&type=script&lang=js&"
export * from "./Providers.vue?vue&type=script&lang=js&"
import style0 from "./Providers.vue?vue&type=style&index=0&id=6f4a3368&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4a3368",
  null
  
)

export default component.exports